// Generated from the supplied legal HTML files; plain data rendered by React (no raw HTML injection).
export type LegalNode = string | { t: string; c?: LegalNode[] };

export const COOKIE: LegalNode[] = [
 {
  "t": "h1",
  "c": [
   "Политика использования файлов cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   {
    "t": "em",
    "c": [
     "Дата публикации: 29.10.2026"
    ]
   }
  ]
 },
 {
  "t": "h2",
  "c": [
   "1. Что такое файлы cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   "Файлы cookie - это небольшие текстовые файлы, которые сохраняются на Вашем устройстве (компьютере, планшете, смартфоне) при посещении https://dev.cs-hub.net/ (далее - Сайт). Файлы cookie позволяют Сайту «запоминать» Ваши действия и настройки в течение определённого периода времени."
  ]
 },
 {
  "t": "h2",
  "c": [
   "2. Оператор"
  ]
 },
 {
  "t": "p",
  "c": [
   "Индивидуальный предприниматель Нерушаев Роман Алексеевич, 141009, обл. Московская, г. Мытищи, ш. Ярославское, д. 120Б, к. 4, кв. 159 (далее - Оператор)."
  ]
 },
 {
  "t": "h2",
  "c": [
   "3. Какие файлы cookie мы используем"
  ]
 },
 {
  "t": "h3",
  "c": [
   "3.1. Строго необходимые файлы cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   "Эти файлы cookie необходимы для функционирования Сайта. Они обеспечивают базовые функции, такие как навигация по страницам и доступ к защищённым областям Сайта. Без этих файлов cookie Сайт не может работать должным образом."
  ]
 },
 {
  "t": "h3",
  "c": [
   "3.2. Аналитические файлы cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   "Эти файлы cookie позволяют нам подсчитывать количество посещений и источники трафика для оценки и улучшения работы нашего Сайта."
  ]
 },
 {
  "t": "p",
  "c": [
   "Используемые сервисы:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "Яндекс.Метрика;"
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h3",
  "c": [
   "3.3. Функциональные файлы cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   "Эти файлы cookie позволяют Сайту запоминать сделанный Вами выбор (например, язык или регион) и предоставлять улучшенные персонализированные функции."
  ]
 },
 {
  "t": "h2",
  "c": [
   "4. Срок хранения файлов cookie"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     {
      "t": "strong",
      "c": [
       "Сессионные файлы cookie"
      ]
     },
     " удаляются автоматически после закрытия веб-браузера."
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     {
      "t": "strong",
      "c": [
       "Постоянные файлы cookie"
      ]
     },
     " хранятся на Вашем устройстве до истечения срока их действия или до их удаления Вами."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h2",
  "c": [
   "5. Как управлять файлами cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   "Вы можете управлять файлами cookie через настройки Вашего веб-браузера:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "удалить все файлы cookie, которые уже сохранены на Вашем устройстве;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "настроить браузер так, чтобы он блокировал установку файлов cookie;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "настроить браузер так, чтобы он уведомлял Вас перед установкой файлов cookie."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "p",
  "c": [
   "Обратите внимание, что отключение файлов cookie может повлиять на функциональность Сайта."
  ]
 },
 {
  "t": "h2",
  "c": [
   "6. Изменения в Политике"
  ]
 },
 {
  "t": "p",
  "c": [
   "Оператор оставляет за собой право вносить изменения в настоящую Политику использования файлов cookie. Актуальная версия Политики всегда доступна на сайте Оператора по адресу https://dev.cs-hub.net/."
  ]
 },
 {
  "t": "h2",
  "c": [
   "7. Контакты"
  ]
 },
 {
  "t": "p",
  "c": [
   "По вопросам, связанным с настоящей Политикой, Вы можете обратиться по адресу электронной почты: Cs2-hub.ru@yandex.ru."
  ]
 }
];

export const TERMS: LegalNode[] = [
 {
  "t": "h1",
  "c": [
   "Пользовательское соглашение"
  ]
 },
 {
  "t": "p",
  "c": [
   {
    "t": "em",
    "c": [
     "Дата публикации: 29.10.2026"
    ]
   }
  ]
 },
 {
  "t": "p",
  "c": [
   "Индивидуальный предприниматель Нерушаев Роман Алексеевич, Индивидуальный предприниматель, ИНН 346101800086, расположенное по адресу: 141009, обл. Московская, г. Мытищи, ш. Ярославское, д. 120Б, к. 4, кв. 159 (далее - «Администрация»), предлагает Вам (далее - «Пользователь») использовать сайт https://dev.cs-hub.net/ (далее - «Сервис») на условиях настоящего Пользовательского соглашения (далее - «Соглашение»)."
  ]
 },
 {
  "t": "p",
  "c": [
   "Настоящее Соглашение вступает в силу с момента Вашего выражения согласия с его условиями."
  ]
 },
 {
  "t": "h2",
  "c": [
   "1. Общие положения"
  ]
 },
 {
  "t": "p",
  "c": [
   "1.1. Настоящее Соглашение определяет условия использования Сервиса, права и обязанности его Пользователей и Администрации."
  ]
 },
 {
  "t": "p",
  "c": [
   "1.2. Настоящее Соглашение является юридически обязывающим договором между Пользователем и Администрацией. Наряду с настоящим Соглашением к отношениям между Пользователем и Администрацией применяется Политика в отношении обработки персональных данных, размещённая на сайте Оператора."
  ]
 },
 {
  "t": "p",
  "c": [
   "1.3. Администрация вправе в любое время в одностороннем порядке изменять условия настоящего Соглашения. Такие изменения вступают в силу по истечении 3 (трёх) дней с момента размещения новой версии Соглашения на Сайте."
  ]
 },
 {
  "t": "p",
  "c": [
   "1.4. Сервис может быть использован несовершеннолетними лицами с согласия их законных представителей (родителей, усыновителей, опекунов, попечителей). Законный представитель, давший согласие на использование Сервиса несовершеннолетним, несёт ответственность за действия несовершеннолетнего при использовании Сервиса."
  ]
 },
 {
  "t": "p",
  "c": [
   "1.5. Начиная использовать Сервис, пройдя процедуру регистрации, Пользователь считается принявшим условия Соглашения в полном объёме."
  ]
 },
 {
  "t": "h2",
  "c": [
   "2. Регистрация и учётная запись"
  ]
 },
 {
  "t": "p",
  "c": [
   "2.1. Для получения доступа к функционалу Сервиса Пользователю необходимо пройти процедуру регистрации, в результате которой для Пользователя будет создана уникальная учётная запись."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.2. При регистрации Пользователь обязан предоставить достоверную и полную информацию о себе."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.3. Пользователь несёт ответственность за безопасность выбранных средств для доступа к учётной записи, а также самостоятельно обеспечивает их конфиденциальность."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.4. Пользователь несёт ответственность за все действия, совершённые с использованием его учётной записи."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.5. Пользователь обязан немедленно уведомить Администрацию о любом случае несанкционированного доступа к Сервису."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.6. Администрация вправе заблокировать или удалить учётную запись Пользователя в случае нарушения условий Соглашения."
  ]
 },
 {
  "t": "h2",
  "c": [
   "3. Оплата и возврат средств"
  ]
 },
 {
  "t": "p",
  "c": [
   "3.1. Стоимость услуг Сервиса определяется в соответствии с действующими тарифами, опубликованными на Сайте."
  ]
 },
 {
  "t": "p",
  "c": [
   "3.2. Оплата осуществляется в безналичной форме с использованием банковских карт или иных платёжных средств, доступных на Сайте."
  ]
 },
 {
  "t": "p",
  "c": [
   "3.3. Обработка платежей осуществляется через банк-эквайер с применением технологии шифрования данных. Администрация не хранит данные банковских карт Пользователей."
  ]
 },
 {
  "t": "p",
  "c": [
   "3.4. Момент оплаты подтверждается уведомлением от платёжной системы."
  ]
 },
 {
  "t": "p",
  "c": [
   "3.5. Возврат денежных средств осуществляется в соответствии с условиями, изложенными в Оферте, размещённой на Сайте."
  ]
 },
 {
  "t": "h2",
  "c": [
   "4. Права и обязанности сторон"
  ]
 },
 {
  "t": "p",
  "c": [
   {
    "t": "strong",
    "c": [
     "Пользователь вправе:"
    ]
   }
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "использовать Сервис в соответствии с условиями настоящего Соглашения;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "обращаться к Администрации по вопросам функционирования Сервиса."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "p",
  "c": [
   {
    "t": "strong",
    "c": [
     "Пользователь обязуется:"
    ]
   }
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "соблюдать условия настоящего Соглашения;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "не нарушать права и законные интересы Администрации и третьих лиц;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "не предпринимать действий, которые могут помешать нормальной работе Сервиса;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "не использовать Сервис в противоправных целях;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "не размещать информацию, которая является незаконной, вредоносной, клеветнической, нарушающей авторские права или иные права третьих лиц."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "p",
  "c": [
   {
    "t": "strong",
    "c": [
     "Администрация вправе:"
    ]
   }
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "в любое время изменять оформление, содержание, функциональность Сервиса;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "приостановить работу Сервиса для проведения технических работ;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "ограничить доступ Пользователя к Сервису в случае нарушения условий настоящего Соглашения."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h2",
  "c": [
   "5. Интеллектуальная собственность"
  ]
 },
 {
  "t": "p",
  "c": [
   "5.1. Все объекты, доступные на Сервисе, в том числе элементы дизайна, текст, графические изображения, иллюстрации, программное обеспечение и другие объекты, а также любой контент, размещённый на Сервисе, являются объектами исключительных прав Администрации и других правообладателей."
  ]
 },
 {
  "t": "p",
  "c": [
   "5.2. Использование контента Сервиса возможно только в рамках функционала, предлагаемого Сервисом. Никакие элементы контента не могут быть использованы иным образом без предварительного разрешения правообладателя."
  ]
 },
 {
  "t": "h2",
  "c": [
   "6. Ответственность сторон"
  ]
 },
 {
  "t": "p",
  "c": [
   "6.1. Администрация не несёт ответственности за любые прямые или косвенные убытки, возникшие в результате использования или невозможности использования Сервиса."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.2. Пользователь самостоятельно несёт ответственность перед третьими лицами за свои действия при использовании Сервиса."
  ]
 },
 {
  "t": "h2",
  "c": [
   "7. Разрешение споров"
  ]
 },
 {
  "t": "p",
  "c": [
   "7.1. В случае возникновения споров стороны будут стремиться к их урегулированию путём переговоров. Претензионный порядок является обязательным, срок ответа на претензию - 30 (тридцать) календарных дней."
  ]
 },
 {
  "t": "p",
  "c": [
   "7.2. При невозможности урегулирования спора путём переговоров он подлежит рассмотрению в суде по месту нахождения Администрации в соответствии с действующим законодательством Российской Федерации."
  ]
 },
 {
  "t": "h2",
  "c": [
   "8. Заключительные положения"
  ]
 },
 {
  "t": "p",
  "c": [
   "8.1. Настоящее Соглашение вступает в силу для Пользователя с момента его присоединения к нему и действует в течение неопределённого срока."
  ]
 },
 {
  "t": "p",
  "c": [
   "8.2. Настоящее Соглашение составлено в соответствии с законодательством Российской Федерации."
  ]
 },
 {
  "t": "p",
  "c": [
   "8.3. По всем вопросам, связанным с настоящим Соглашением, Пользователь может обратиться к Администрации по адресу электронной почты: Cs2-hub.ru@yandex.ru."
  ]
 },
 {
  "t": "p",
  "c": [
   "8.4. Актуальная версия настоящего Соглашения размещена на сайте Оператора по адресу https://dev.cs-hub.net/."
  ]
 }
];

export const CONSENT: LegalNode[] = [
 {
  "t": "h1",
  "c": [
   "Согласие на обработку персональных данных"
  ]
 },
 {
  "t": "p",
  "c": [
   "Настоящим я, субъект персональных данных (далее - Пользователь), свободно, своей волей и в своём интересе даю Индивидуальный предприниматель Нерушаев Роман Алексеевич (далее - Оператор), расположенному по адресу: 141009, обл. Московская, г. Мытищи, ш. Ярославское, д. 120Б, к. 4, кв. 159, согласие на обработку моих персональных данных, указанных при регистрации на сайте https://dev.cs-hub.net/ (далее - Сайт), направляемой (заполненной) с использованием Сайта."
  ]
 },
 {
  "t": "h3",
  "c": [
   "Перечень персональных данных, на обработку которых даётся согласие:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "адрес электронной почты;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "платёжные данные (реквизиты банковской карты);"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "фотография / аватар;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "Никнеймы;"
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h3",
  "c": [
   "Цели обработки персональных данных:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "предоставление Пользователю доступа к персонализированным ресурсам Сайта;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "идентификация Пользователя, зарегистрированного на Сайте, для установления с ним обратной связи;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "обработка и получение платежей от Пользователя;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "установление обратной связи с Пользователем, включая направление уведомлений, запросов, касающихся использования Сайта, оказания услуг, а также обработка запросов и заявок от Пользователя;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "проведение статистических и иных исследований на основе обезличенных данных;"
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h3",
  "c": [
   "Перечень действий с персональными данными, на совершение которых даётся согласие:"
  ]
 },
 {
  "t": "p",
  "c": [
   "сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение."
  ]
 },
 {
  "t": "h3",
  "c": [
   "Общее описание способов обработки:"
  ]
 },
 {
  "t": "p",
  "c": [
   "Обработка персональных данных осуществляется с использованием средств автоматизации и/или без использования таких средств."
  ]
 },
 {
  "t": "h3",
  "c": [
   "Срок действия согласия:"
  ]
 },
 {
  "t": "p",
  "c": [
   "Согласие действует до момента его отзыва путём направления соответствующего уведомления на электронный адрес Cs2-hub.ru@yandex.ru."
  ]
 },
 {
  "t": "p",
  "c": [
   "Пользователь подтверждает, что, давая настоящее согласие, он действует свободно, своей волей и в своём интересе."
  ]
 },
 {
  "t": "h3",
  "c": [
   "Обработка данных несовершеннолетних:"
  ]
 },
 {
  "t": "p",
  "c": [
   "В случае обработки персональных данных несовершеннолетних, согласие на обработку предоставляется законным представителем (родителем, усыновителем, опекуном, попечителем) несовершеннолетнего в соответствии со статьёй 9 Федерального закона от 27.07.2006 №152-ФЗ «О персональных данных». Законный представитель вправе в любой момент отозвать данное согласие, направив уведомление на электронный адрес Cs2-hub.ru@yandex.ru."
  ]
 }
];

export const PRIVACY: LegalNode[] = [
 {
  "t": "h1",
  "c": [
   "Политика в отношении обработки персональных данных"
  ]
 },
 {
  "t": "p",
  "c": [
   {
    "t": "em",
    "c": [
     "Дата публикации: 29.10.2026"
    ]
   }
  ]
 },
 {
  "t": "h2",
  "c": [
   "1. Общие положения"
  ]
 },
 {
  "t": "p",
  "c": [
   "Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006 №152-ФЗ «О персональных данных» (далее - Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые Индивидуальный предприниматель Нерушаев Роман Алексеевич (далее - Оператор)."
  ]
 },
 {
  "t": "p",
  "c": [
   "1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну."
  ]
 },
 {
  "t": "p",
  "c": [
   "1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее - Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта https://dev.cs-hub.net/."
  ]
 },
 {
  "t": "h2",
  "c": [
   "2. Основные понятия, используемые в Политике"
  ]
 },
 {
  "t": "p",
  "c": [
   "2.1. ",
   {
    "t": "strong",
    "c": [
     "Автоматизированная обработка персональных данных"
    ]
   },
   " - обработка персональных данных с помощью средств вычислительной техники."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.2. ",
   {
    "t": "strong",
    "c": [
     "Блокирование персональных данных"
    ]
   },
   " - временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных)."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.3. ",
   {
    "t": "strong",
    "c": [
     "Веб-сайт"
    ]
   },
   " - совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети Интернет по сетевому адресу https://dev.cs-hub.net/."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.4. ",
   {
    "t": "strong",
    "c": [
     "Оператор"
    ]
   },
   " - Индивидуальный предприниматель, самостоятельно или совместно с другими лицами организующее и (или) осуществляющее обработку персональных данных, а также определяющее цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.5. ",
   {
    "t": "strong",
    "c": [
     "Персональные данные"
    ]
   },
   " - любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта https://dev.cs-hub.net/."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.6. ",
   {
    "t": "strong",
    "c": [
     "Пользователь"
    ]
   },
   " - любое лицо, имеющее доступ к веб-сайту https://dev.cs-hub.net/ посредством сети Интернет и использующее его."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.7. ",
   {
    "t": "strong",
    "c": [
     "Обработка персональных данных"
    ]
   },
   " - любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных."
  ]
 },
 {
  "t": "p",
  "c": [
   "2.8. ",
   {
    "t": "strong",
    "c": [
     "Предоставление персональных данных"
    ]
   },
   " - действия, направленные на раскрытие персональных данных определённому лицу или определённому кругу лиц."
  ]
 },
 {
  "t": "h2",
  "c": [
   "3. Основные права и обязанности Оператора"
  ]
 },
 {
  "t": "p",
  "c": [
   "3.1. Оператор имеет право:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Законе о персональных данных;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "p",
  "c": [
   "3.2. Оператор обязан:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Закона о персональных данных;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого органа необходимую информацию в течение 10 дней с даты получения такого запроса;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "принимать правовые, организационные и технические меры для защиты персональных данных;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "прекратить передачу, обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h2",
  "c": [
   "4. Основные права субъектов персональных данных"
  ]
 },
 {
  "t": "p",
  "c": [
   "4.1. Субъекты персональных данных имеют право:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "получать информацию, касающуюся обработки его персональных данных;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "требовать от Оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "на отзыв согласия на обработку персональных данных;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h2",
  "c": [
   "5. Оператор может обрабатывать следующие персональные данные Пользователя"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "адрес электронной почты;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "платёжные данные (реквизиты банковской карты);"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "фотография / аватар;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "Никнеймы;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "сведения об оплате (идентификатор транзакции, дата и сумма платежа). Данные банковских карт не обрабатываются и не хранятся Оператором - обработка осуществляется банком-эквайером."
    ]
   },
   "\n"
  ]
 },
 {
  "t": "p",
  "c": [
   "Также на Сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов cookie) с помощью сервисов интернет-статистики."
  ]
 },
 {
  "t": "h2",
  "c": [
   "6. Принципы обработки персональных данных"
  ]
 },
 {
  "t": "p",
  "c": [
   "6.1. Обработка персональных данных осуществляется на законной и справедливой основе."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.2. Обработка персональных данных ограничивается достижением конкретных, заранее определённых и законных целей."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.5. Содержание и объём обрабатываемых персональных данных соответствуют заявленным целям обработки."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.6. При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки."
  ]
 },
 {
  "t": "p",
  "c": [
   "6.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных."
  ]
 },
 {
  "t": "h2",
  "c": [
   "7. Цели обработки персональных данных"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "предоставление Пользователю доступа к персонализированным ресурсам Сайта;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "идентификация Пользователя, зарегистрированного на Сайте, для установления с ним обратной связи;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "обработка и получение платежей от Пользователя;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "установление обратной связи с Пользователем, включая направление уведомлений, запросов, касающихся использования Сайта, оказания услуг, а также обработка запросов и заявок от Пользователя;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "проведение статистических и иных исследований на основе обезличенных данных;"
    ]
   },
   "\n"
  ]
 },
 {
  "t": "h2",
  "c": [
   "8. Условия обработки персональных данных"
  ]
 },
 {
  "t": "p",
  "c": [
   "8.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных."
  ]
 },
 {
  "t": "p",
  "c": [
   "8.2. Обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом."
  ]
 },
 {
  "t": "p",
  "c": [
   "8.3. Обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных."
  ]
 },
 {
  "t": "p",
  "c": [
   "8.4. Обработка персональных данных необходима для осуществления прав и законных интересов Оператора или третьих лиц при условии, что при этом не нарушаются права и свободы субъекта персональных данных."
  ]
 },
 {
  "t": "h2",
  "c": [
   "9. Порядок сбора, хранения, передачи и других видов обработки персональных данных"
  ]
 },
 {
  "t": "p",
  "c": [
   "Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путём реализации правовых, организационных и технических мер, необходимых для выполнения в полном объёме требований действующего законодательства в области защиты персональных данных."
  ]
 },
 {
  "t": "p",
  "c": [
   "9.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц."
  ]
 },
 {
  "t": "p",
  "c": [
   "9.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства."
  ]
 },
 {
  "t": "p",
  "c": [
   "9.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путём направления Оператору уведомления на адрес электронной почты Оператора Cs2-hub.ru@yandex.ru с пометкой «Актуализация персональных данных»."
  ]
 },
 {
  "t": "p",
  "c": [
   "9.4. Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные данные, если иной срок не предусмотрен договором или действующим законодательством."
  ]
 },
 {
  "t": "p",
  "c": [
   "Пользователь может в любой момент отозвать своё согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора Cs2-hub.ru@yandex.ru с пометкой «Отзыв согласия на обработку персональных данных»."
  ]
 },
 {
  "t": "p",
  "c": [
   "9.5. Персональные данные Пользователей хранятся исключительно на электронных носителях и обрабатываются с использованием автоматизированных систем. Хранение персональных данных осуществляется на территории Российской Федерации в соответствии с требованиями Федерального закона от 21.07.2014 №242-ФЗ."
  ]
 },
 {
  "t": "h2",
  "c": [
   "10. Перечень действий, производимых Оператором с полученными персональными данными"
  ]
 },
 {
  "t": "p",
  "c": [
   "10.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление и уничтожение персональных данных."
  ]
 },
 {
  "t": "p",
  "c": [
   "10.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей полученной информации по информационно-телекоммуникационным сетям или без таковой."
  ]
 },
 {
  "t": "h2",
  "c": [
   "11. Использование файлов cookie"
  ]
 },
 {
  "t": "p",
  "c": [
   "11.1. Для обеспечения работы https://dev.cs-hub.net/ Оператор использует файлы cookie - небольшие текстовые файлы, которые сохраняются на устройстве Пользователя."
  ]
 },
 {
  "t": "p",
  "c": [
   "11.2. Файлы cookie могут использоваться для следующих целей:"
  ]
 },
 {
  "t": "ul",
  "c": [
   "\n    ",
   {
    "t": "li",
    "c": [
     "обеспечение функционирования Сайта;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "сбор и анализ статистики посещений;"
    ]
   },
   "\n    ",
   {
    "t": "li",
    "c": [
     "улучшение качества работы Сайта;"
    ]
   },
   "\n"
  ]
 },
 {
  "t": "p",
  "c": [
   "11.3. Пользователь может в любой момент отключить использование файлов cookie в настройках своего веб-браузера. Отключение файлов cookie может повлиять на функциональность https://dev.cs-hub.net/."
  ]
 },
 {
  "t": "h2",
  "c": [
   "12. Обработка персональных данных несовершеннолетних"
  ]
 },
 {
  "t": "p",
  "c": [
   "12.1. Оператор может осуществлять обработку персональных данных несовершеннолетних лиц."
  ]
 },
 {
  "t": "p",
  "c": [
   "12.2. Обработка персональных данных несовершеннолетних осуществляется с согласия законных представителей (родителей, усыновителей, опекунов, попечителей) в соответствии со статьёй 9 Федерального закона от 27.07.2006 №152-ФЗ «О персональных данных»."
  ]
 },
 {
  "t": "p",
  "c": [
   "12.3. Оператор принимает дополнительные меры по защите персональных данных несовершеннолетних и обеспечивает их обработку исключительно в целях, для которых они были предоставлены."
  ]
 },
 {
  "t": "p",
  "c": [
   "12.4. Законный представитель несовершеннолетнего вправе в любой момент отозвать согласие на обработку персональных данных, направив уведомление на электронный адрес Cs2-hub.ru@yandex.ru."
  ]
 },
 {
  "t": "h2",
  "c": [
   "13. Заключительные положения"
  ]
 },
 {
  "t": "p",
  "c": [
   "13.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты Cs2-hub.ru@yandex.ru."
  ]
 },
 {
  "t": "p",
  "c": [
   "13.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены её новой версией."
  ]
 },
 {
  "t": "p",
  "c": [
   "13.3. Актуальная версия Политики в свободном доступе расположена на сайте Оператора по адресу https://dev.cs-hub.net/."
  ]
 },
 {
  "t": "hr"
 },
 {
  "t": "p",
  "c": [
   {
    "t": "strong",
    "c": [
     "Оператор:"
    ]
   },
   {
    "t": "br"
   },
   "\nИндивидуальный предприниматель Нерушаев Роман Алексеевич",
   {
    "t": "br"
   },
   "\nИНН: 346101800086",
   {
    "t": "br"
   },
   "141009, обл. Московская, г. Мытищи, ш. Ярославское, д. 120Б, к. 4, кв. 159",
   {
    "t": "br"
   },
   "\nCs2-hub.ru@yandex.ru",
   {
    "t": "br"
   },
   "Ответственный за обработку персональных данных: Нерушаев Роман Алексеевич"
  ]
 }
];
